module.exports = __webpack_public_path__ + "static/scale-model-of-wegerzyn-gardens-metropark-in-dayton-ohio-75e7679d8b04e1013455c1ce18fd0b87.png";